// src/router/AdminRouter.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout, AdminLayoutTop } from "../layouts";
// Fase 1A M4 - K12 Free Refactor: eliminadas paginas Page_Teacher_free.
// El teacher con plan free ahora usa las mismas paginas que un teacher
// con plan pagado. Los limites (educamaker, etc) los aplica el server
// via plan_key (Fase 1A M3) o quotas en handlers.
import {
  ForgotPasswordForm,
  ResetPasswordForm,
} from "../components/Admin/Auth";
import {
  Auth,
  AuthTeacherstudents,
  Page_Partner_Profile,
  Page_Partner_Institution,
  Page_Partner_Facturation,
  Page_PartnerDashboard,
  Page_PartnerInstitutionDetail,
  Page_Support_Partner,
  Page_Institution_Profile,
  Page_Institution_Class,
  Page_Institution_Teacher,
  Page_Institution_Student,
  Page_Institution_Support,
  Page_Institution_Facturation,
  Page_InstitutionDashboard,
  PageWelcome,
  Page_Teacher_Salas,
  Page_Teacher_evalucacion,
  Page_Teacher_Tareas,
  VirtualScenes,
  Page_Teacher_Quiz,
  Page_Guia,
  PageStudentsHome,
  Page_UserFreeSalas,
  Page_UIMaterials,
  Page_Assistant,
  AuthPartner,
  Page_Styles,
  Page_StylesAccess,
  Page_Formacion,
  Page_Formacion_Institution,
} from "../pages/portal";
import { useAuth } from "../hooks";
import { useStylesAccessStore } from "../store/stylesAccessStore";
import { NEW_STUDENT_HOME, NEW_TEACHER_TRAINING } from "../ui/featureFlags";
import { StudentPortalEntry } from "../components/StudentPortal";

export function AdminRouter() {
  const { user } = useAuth();
  const stylesGrant = useStylesAccessStore((s) => s.grant);

  //if (user === null) return null;
  // Fase 1A M4 - K12 Free Refactor: eliminado el sobrescribir role a
  // "teacherfree" cuando account==="free". Ahora todos los teachers
  // (free y pagados) entran al mismo conjunto de paginas; la
  // diferencia operacional la marca el plan (JWT plan_key + middleware
  // checkPlanActive de M3 cuando se aplique).
  const role = user?.user?.role; // p.ej. "admin", "teacher", etc.

  // Función para inyectar un Page dentro de un Layout
  const loadLayout = (Layout, Page) => (
    <Layout>
      <Page />
    </Layout>
  );

  // Rutas específicas según el rol
  const roleRoutes = {
    admin: [
      {
        path: "register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      },
      {
        path: "institution",
        element: loadLayout(AdminLayout, Page_Partner_Institution),
      },
    ],
    teacher: [
      {
        path: "teacher/salas",
        element: loadLayout(AdminLayout, Page_Teacher_Salas),
      },
      {
        path: "teacher/assistant",
        element: loadLayout(AdminLayout, Page_Assistant),
      },
      {
        path: "teacher/evaluacion",
        element: loadLayout(AdminLayout, Page_Teacher_evalucacion),
      },
      {
        path: "teacher/tareas",
        element: loadLayout(AdminLayout, Page_Teacher_Tareas),
      },
      {
        path: "teacher/educamaker",
        element: loadLayout(AdminLayout, VirtualScenes),
      },
      {
        path: "teacher/quiz",
        element: loadLayout(AdminLayout, Page_Teacher_Quiz),
      },
      {
        path: "teacher/guia/:id",
        element: loadLayout(AdminLayout, Page_Guia),
      },
      // Formacion: videos, guias PDF e info de uso de la plataforma. Misma
      // pagina que la institucion, con la audiencia del profesor.
      ...(NEW_TEACHER_TRAINING
        ? [
            {
              path: "teacher/formacion",
              element: loadLayout(AdminLayout, Page_Formacion),
            },
          ]
        : []),
    ],
    // Fase 1A M4 - eliminada rama teacherfree. Los teachers con plan
    // free entran via la rama `teacher` arriba.
    student: [
      {
        path: "student/home",
        // Strangler (Capa 2): con NEW_STUDENT_HOME=true se monta el portal nuevo
        // (trae su propio shell, sin AdminLayoutTop). En false, portal actual.
        element: NEW_STUDENT_HOME ? (
          <StudentPortalEntry />
        ) : (
          loadLayout(AdminLayoutTop, PageStudentsHome)
        ),
      },
    ],
    institution: [
      {
        path: "inst/profile",
        element: loadLayout(AdminLayout, Page_Institution_Profile),
      },
      {
        path: "inst/class",
        element: loadLayout(AdminLayout, Page_Institution_Class),
      },
      {
        path: "inst/teachers",
        element: loadLayout(AdminLayout, Page_Institution_Teacher),
      },
      {
        path: "inst/students",
        element: loadLayout(AdminLayout, Page_Institution_Student),
      },
      {
        path: "inst/facturation",
        element: loadLayout(AdminLayout, Page_Institution_Facturation),
      },
      {
        path: "inst/dashboard",
        element: loadLayout(AdminLayout, Page_InstitutionDashboard),
      },
      {
        path: "inst/support",
        element: loadLayout(AdminLayout, Page_Institution_Support),
      },
      ...(NEW_TEACHER_TRAINING
        ? [
            {
              path: "inst/formacion",
              element: loadLayout(AdminLayout, Page_Formacion_Institution),
            },
          ]
        : []),
    ],
    partner: [
      {
        path: "partner/register",
        element: loadLayout(AdminLayout, Page_Partner_Profile),
      },
      {
        path: "partner/institution",
        element: loadLayout(AdminLayout, Page_Partner_Institution),
      },
      {
        path: "partner/facturation",
        element: loadLayout(AdminLayout, Page_Partner_Facturation),
      },
      {
        path: "partner/dashboard",
        element: loadLayout(AdminLayout, Page_PartnerDashboard),
      },
      {
        path: "partner/institutions/:id", // <--- Añadimos /:id y ajustamos el nombre
        element: loadLayout(AdminLayout, Page_PartnerInstitutionDetail),
      },
      {
        path: "partner/support",
        element: loadLayout(AdminLayout, Page_Support_Partner),
      },
    ],
    user: [
      {
        path: "userfree/salas",
        element: loadLayout(AdminLayout, Page_UserFreeSalas),
      },
      {
        path: "userfree/guia/:id",
        element: loadLayout(AdminLayout, Page_Guia),
      },
    ],
    // Podrías definir student, user, etc.
  };

  // Ruta por defecto según el rol
  const defaultPathByRole = {
    admin: "portal/register",
    partner: "portal/partner/register",
    institution: "portal/inst/profile",
    teacher: "/portal/teacher/salas",
    student: "portal/student/home",
    user: "userfree/salas",
  };

  // Se eligen las rutas según el rol de user
  const availableRoutes = roleRoutes[role] || [];
  // Si no existe coincidencia, fallback a "auth"
  const defaultPath = defaultPathByRole[role] || "auth";

  return (
    <Routes>
      {/* Ruta accesible sin user */}
      <Route path="/auth-institution" element={<AuthTeacherstudents />} />

      {/* Si no hay user => rutas públicas (Auth) */}
      {!user ? (
        <>
          {/* Ruta normal de login */}
          <Route path="/auth" element={<Auth />} />
          {/* Recuperación y restablecimiento */}
          <Route
            path="/recuperar-contraseña"
            element={<ForgotPasswordForm />}
          />
          <Route path="/reset-password" element={<ResetPasswordForm />} />
          <Route path="/partner/auth" element={<AuthPartner />} />
          {/* Cualquier otra ruta sin user => redirige a /auth */}
          <Route path="*" element={<Navigate to="/auth" />} />
        </>
      ) : (
        <>
          {/* Rutas definidas para este rol */}
          {availableRoutes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}

          {/* Fase 1A M5 - Onboarding welcome (sin AdminLayout = full screen) */}
          <Route path="welcome" element={<PageWelcome />} />

          {/* Ruta para materiales UI */}
          <Route
            path="materials"
            element={loadLayout(AdminLayout, Page_UIMaterials)}
          />

          {/* Puerta oculta de acceso al editor (OTP). URL a mano; cualquier
              profesor logueado. */}
          <Route
            path="teacher/styles-access"
            element={loadLayout(AdminLayout, Page_StylesAccess)}
          />

          {/* Editor de estilos — solo con grant verificado (OTP), por sesion */}
          <Route
            path="estilos"
            element={
              stylesGrant ? (
                loadLayout(AdminLayout, Page_Styles)
              ) : (
                <Navigate to="/portal/teacher/styles-access" replace />
              )
            }
          />

          {/* Al acceder a /portal/ (el “index”), vamos al defaultPath */}
          <Route index element={<Navigate to={defaultPath} replace />} />

          {/* Cualquier otra ruta inválida → al mismo defaultPath */}
          <Route path="*" element={<Navigate to={defaultPath} replace />} />
        </>
      )}
    </Routes>
  );
}
